import { combineReducers } from 'redux';
// import reducers
import auth from './auth';
import profile from './profile';

const rootReducer = combineReducers({
    auth: auth,
    profile: profile
});

export default rootReducer;
